import React from "react";

import {
    Group,
    Option,
    OptionDescription,
    OptionLabel,
    OptionText,
    Radio,
} from "./styles";

export interface RadioOption<T extends string> {
    value: T;
    label: React.ReactNode;
    description?: React.ReactNode;
}

interface RadioGroupProps<T extends string> {
    value: T;
    options: RadioOption<T>[];
    onChange: (value: T) => void;
    disabled?: boolean;
    className?: string;
}

export function RadioGroup<T extends string>({
    value,
    options,
    onChange,
    disabled,
    className,
}: RadioGroupProps<T>) {
    return (
        <Group className={className}>
            {options.map((option) => (
                <Option
                    key={option.value}
                    $active={option.value === value}
                    $disabled={disabled}
                >
                    <Radio
                        type="radio"
                        checked={option.value === value}
                        disabled={disabled}
                        onChange={() => onChange(option.value)}
                    />
                    <OptionText>
                        <OptionLabel>{option.label}</OptionLabel>
                        {option.description && (
                            <OptionDescription>{option.description}</OptionDescription>
                        )}
                    </OptionText>
                </Option>
            ))}
        </Group>
    );
}
